// extracted by mini-css-extract-plugin
export default {"loginStyle":"Login_loginStyle__Buuwf","boxStyle":"Login_boxStyle__4Z-co","logoColor":"Login_logoColor__u7w9C","btnStyle":"Login_btnStyle__jI3nq"};